import { render, staticRenderFns } from "./PlayerRegistrationInfoModal.vue?vue&type=template&id=243c0535&"
import script from "./PlayerRegistrationInfoModal.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationInfoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports